module.exports = __webpack_public_path__ + "img/footer_img1.4e5fbe3d.png";